import { render } from "./WorkflowBacklog.vue?vue&type=template&id=69543751&scoped=true"
import script from "./WorkflowBacklog.vue?vue&type=script&lang=js"
export * from "./WorkflowBacklog.vue?vue&type=script&lang=js"

import "./WorkflowBacklog.vue?vue&type=style&index=0&id=69543751&scoped=true&lang=css"
import "./WorkflowBacklog.vue?vue&type=style&index=1&id=69543751&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69543751"]])

export default __exports__